import React, { useState, useRef } from "react"
import { connect } from "react-redux"
import { showNotificationWithTimeout } from "../../_actions/adminAlertActionCreator"
import DialogBox from "../../common/DialogBox"
import { API_FORM } from "../../api"

function UploadProof({
  toggleUploadBox,
  orderUUID,
  paymentDetail,
  updateOrderData,
  showAlert,
  isRefunded
}) {
  let editableImage = null
  let initialPaymentImage = null
  const hasVerified =
    (paymentDetail &&
      paymentDetail.image &&
      paymentDetail.image.length > 0 &&
      paymentDetail.image[0].is_verified) ||
    false

  if (hasVerified) {
    initialPaymentImage = paymentDetail.image[0].url
    if (paymentDetail.image.length > 1) {
      editableImage = paymentDetail.image[1].url
    }
  } else {
    if (paymentDetail.image.length > 0) {
      editableImage = paymentDetail.image[0].url
    }
  }

  const imageInput = useRef(null)
  const [proof, setProof] = useState(editableImage || "")
  const [preview, setPreview] = useState(editableImage || "")
  const [error, setError] = useState("")
  const [uploading, setUploading] = useState(false)
  const [view, setView] = useState("form")

  const formDirty =
    (editableImage && proof !== editableImage) ||
    (!editableImage && proof !== "")

  function handleProofChange(e) {
    if (
      e.target.files &&
      e.target.files[0] &&
      (e.target.files[0].type === "image/jpeg" ||
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/gif")
    ) {
      setError("")
      setProof(e.target.files[0].name)
      const reader = new FileReader()
      reader.onload = rEvent => {
        setPreview(rEvent.target.result)
      }
      reader.readAsDataURL(e.target.files[0])
    } else if (
      e.target.files &&
      e.target.files[0] &&
      (e.target.files[0].type !== "image/jpeg" ||
        e.target.files[0].type !== "image/png" ||
        e.target.files[0].type !== "image/gif")
    ) {
      setError("The file chosen must be an image.")
    } else {
      setProof("")
      setPreview("")
    }
  }

  function handleViewChange(e) {
    const val = e.currentTarget.value
    setView(val)
  }

  async function getImageUrl() {
    if (formDirty && !uploading) {
      try {
        const file =
          (imageInput.current.files &&
            imageInput.current.files.length > 0 &&
            imageInput.current.files[0]) ||
          null
        setUploading(true)
        if (file) {
          const formData = new FormData()
          formData.append("image", file)
          formData.append("source", "customer")
          formData.append("photo_url", "")
          await API_FORM.post(`/checkout/${orderUUID}/payment`, formData)
          updateOrderData && (await updateOrderData())
          showAlert({
            message: "Proof of payment saved.",
            type: "success",
            consumer: "checkout"
          })
          toggleUploadBox()
        }
      } catch (error) {
        console.log(error.response || error)
        setUploading(false)
      }
    }
  }

  return (
    <DialogBox
      primaryAction={getImageUrl}
      primaryActionLabel={
        editableImage
          ? uploading
            ? "Saving..."
            : "Save"
          : uploading
            ? "Uploading..."
            : "Upload"
      }
      secondaryAction={!uploading ? toggleUploadBox : () => {}}
      secondaryActionLabel="Cancel"
      close={!uploading ? toggleUploadBox : () => {}}
      closeLabel="Cancel"
      title={
        view === "initial" || editableImage
          ? "VIEW PROOF OF PAYMENT"
          : "UPLOAD PROOF OF PAYMENT"
      }
      hideButton={view !== "form" || isRefunded}
    >
      {(hasVerified && (
        <form className="radio-form">
          <div>
            <span className="radio">
              <input
                name="imageDisplay"
                value="initial"
                type="radio"
                onChange={handleViewChange}
                checked={view === "initial"}
              />
              <label htmlFor="">Initial Payment</label>
            </span>
            <span className="radio">
              <input
                name="imageDisplay"
                value="form"
                type="radio"
                onChange={handleViewChange}
                checked={view === "form"}
              />
              <label htmlFor="">Remaining Balance</label>
            </span>
          </div>
        </form>
      )) || (
        <span className="sub-title">
          Please upload your bank deposit slips, screenshots of fund transfer,
          payment slips, etc.
        </span>
      )}
      <div className="image-upload">
        <span>Proof of Payment</span>
        {view === "form" ? (
          <>
            {!isRefunded && (
              <>
                <div className="image-upload-form">
                  <span>
                    {(proof &&
                      !(
                        proof.toLowerCase().includes("http://") ||
                        proof.toLowerCase().includes("https://")
                      ) &&
                      proof) ||
                      null}
                  </span>
                  <label htmlFor="proof">
                    {(editableImage && "Change File") || "Choose File"}
                  </label>
                  <input
                    type="file"
                    name="proof"
                    id="proof"
                    className="proof-input"
                    accept="image/*"
                    onChange={handleProofChange}
                    ref={imageInput}
                    disabled={uploading}
                  />
                </div>
                {error && (
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#eb6b6b",
                      marginTop: "10px"
                    }}
                  >
                    {error}
                  </div>
                )}
              </>
            )}
            {preview &&
              preview !== "" && (
                <img src={preview} alt="preview" className="proof-preview" />
              )}
          </>
        ) : null}
        {view === "initial" && (
          <>
            <img
              src={initialPaymentImage}
              alt="preview"
              className="proof-preview"
            />
          </>
        )}
      </div>
    </DialogBox>
  )
}

const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  }
})

export default connect(
  null,
  mapDispatchToProps
)(UploadProof)
